// extracted by mini-css-extract-plugin
export default {"app":"app_app__OsQoD","layout":"app_layout__cm1xu"};